import React from 'react'
import {Button, Dropdown, Space} from "antd";
import {FileExcelOutlined} from "@ant-design/icons";
import {EXPORT_BUTTONS_CONFIG} from "../constant/exportConfig";
import GenericExportButton from "./GenericExportButton";
import checkRole from "../../../../helpers/checkRole";

const ExportContainer = ({filters, tenants, level}) => {
    const standardItems = EXPORT_BUTTONS_CONFIG.standard.map((config) => ({
        key: config.id,
        label: (
            <GenericExportButton
                apiFunction={config.apiFunction}
                buttonText={config.buttonText}
                fileName={config.fileName}
                filters={filters}
                tenants={tenants}
                level={level}
                needsLevel={config.needsLevel}
                needsTenantName={config.needsTenantName}
                className="dropdown-export-btn"
                buttonType="text"
                icon={null}
            />
        )
    }))

    const zenifyItems = EXPORT_BUTTONS_CONFIG.zenify.map((config) => {
        if (config.id !== 'export-history-payment') {
            return {
                key: config.id,
                label: (
                    <GenericExportButton
                        apiFunction={config.apiFunction}
                        buttonText={config.buttonText}
                        fileName={config.fileName}
                        filters={filters}
                        tenants={tenants}
                        level={level}
                        needsLevel={config.needsLevel}
                        needsTenantName={config.needsTenantName}
                        className="dropdown-export-btn"
                        buttonType="text"
                        icon={null}
                    />
                )
            }
        } else if (config.id === 'export-history-payment') {
            if (checkRole('menu.report.admin.topup.history')) {
                return {
                    key: config.id,
                    label: (
                        <GenericExportButton
                            apiFunction={config.apiFunction}
                            buttonText={config.buttonText}
                            fileName={config.fileName}
                            filters={filters}
                            tenants={tenants}
                            level={level}
                            needsLevel={config.needsLevel}
                            needsTenantName={config.needsTenantName}
                            className="dropdown-export-btn"
                            buttonType="text"
                            icon={null}
                        />
                    )
                }
            }
        }
    })

    const anotherItems = EXPORT_BUTTONS_CONFIG.another.map((config) => {
        if (checkRole('menu.report.admin.topup.history')) {
            return {
                key: config.id,
                label: (
                    <GenericExportButton
                        apiFunction={config.apiFunction}
                        buttonText={config.buttonText}
                        fileName={config.fileName}
                        filters={filters}
                        tenants={tenants || []}
                        level={level}
                        needsLevel={config.needsLevel}
                        needsTenantName={config.needsTenantName}
                        className="dropdown-export-btn"
                        buttonType="text"
                        icon={null}
                        isBreakDisabled={true}
                    />
                )
            }
        }
    })

    const isDisabled = !filters.tenantId || filters.tenantId.length === 0

    return (
        <div className="ExportContainer">
            <Space>
                <Dropdown
                    menu={{items: standardItems}}
                    placement="bottomLeft"
                    disabled={isDisabled}
                    trigger={['click']}
                    overlayClassName='export-content-custom'
                >
                    <Button
                        className="export-button-custom"
                        type="primary"
                        icon={<FileExcelOutlined/>}
                        disabled={isDisabled}
                        size="large"
                    >
                        Báo cáo CallStack
                    </Button>
                </Dropdown>
                <Dropdown
                    menu={{items: zenifyItems}}
                    placement="bottomLeft"
                    disabled={isDisabled}
                    trigger={['click']}
                    overlayClassName='export-content-custom'
                >
                    <Button
                        className="export-button-custom"
                        type="primary"
                        icon={<FileExcelOutlined/>}
                        disabled={isDisabled}
                        size="large"
                    >
                        Báo cáo Zenify
                    </Button>
                </Dropdown>
                <Dropdown
                    menu={{items: anotherItems}}
                    placement="bottomLeft"
                    trigger={['click']}
                    overlayClassName='export-content-custom'
                >
                    <Button
                        className="export-button-custom"
                        type="primary"
                        icon={<FileExcelOutlined/>}
                        size="large"
                    >
                        Báo cáo khác
                    </Button>
                </Dropdown>
            </Space>
        </div>
    )
}

export default ExportContainer